import { render, staticRenderFns } from "./PoiPicker.vue?vue&type=template&id=1c5a4b90&scoped=true&"
import script from "./PoiPicker.vue?vue&type=script&lang=js&"
export * from "./PoiPicker.vue?vue&type=script&lang=js&"
import style0 from "./PoiPicker.vue?vue&type=style&index=0&id=1c5a4b90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5a4b90",
  null
  
)

export default component.exports